module.exports = __webpack_public_path__ + "resources/img/img_ahnlab_vtrusguard_en.1e9cd1dd70478c6f113cb5ad7ce58509.png";